import React, { PureComponent, Fragment } from "react";
import { QUERY_LIST_GROUPS } from "./../Queries";
import { withRouter } from "react-router-dom";
import { AppContext } from "../contexts/AppContextProvider";
import {
  PageContextConsumer,
  PageContextProvider,
} from "../contexts/PageContextPovider";

import Footer from "./Footer/Footer.js";
import Alert from "./Alert/Alert.js";
import { Query } from "@apollo/client/react/components";
import Page from "./Page";

import Downshift from "downshift";
import clsx from "clsx";
import Heading from "./Elements/Heading";
import { Notification } from "./Utils/Utils.js";

import { getTextWidth } from "./Utils/Utils";
import client from "../client";
import PageFilterContainerLoadDimensions from "./PageFilterContainerLoadDimensions";
export const DEFAULT_FILTER = {
  name: "All",
  id: -1,
  friendlyName: "All",
};

class PageContainer extends PureComponent {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      // defines when the data was loaded from the context in order to do some calculations
      // and don't allow to render the page while the data wasn't loaded yet
      contextDataLoaded: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.default_group = this.getActiveBoard().defaultGroup || false;
      this.default_region = this.getActiveBoard().defaultRegion || false;
      this.default_filter = this.getActiveBoard().defaultFilter || false;

      this.updatePageSettings({
        group_name: this.default_group.name || "All Accounts",
        group_slug: this.default_group.slug || "all",
        region_slug: this.default_region.slug || null,
      });
      this.setState({
        region_name: "All Regions",
        input_groups_width: {
          width: getTextWidth(this.default_group.name || "All Accounts"),
        },
        input_filter_width: {
          width: getTextWidth(this.default_filter.name || DEFAULT_FILTER.name),
        },
        input_regions_width: {
          width: getTextWidth(this.default_region.name || "All Regions"),
        },
        regions: this.getRegions().length > 0 ? this.getRegions() : false,
      });
    }
  }

  getRegions = () =>
    this.getActiveBoard().regions.sort((a, b) => (a.name > b.name ? 1 : -1)) ||
    false;

  getActiveBoard = () => {
    const { currentProject } = this.context.state;
    return currentProject.data.projects
      .find((p) => p.slug === currentProject.project)
      .boards.find((b) => b.slug === currentProject.page);
  };

  onChangeGroup = (selected_item, event, data) => {
    const { currentProject } = this.context.state;
    // Remove focus
    document.getElementById(event.id + "-input").blur();

    const group_slug = data.find(({ name }) => name === selected_item).slug;

    this.updatePageSettings({
      group_name: selected_item,
      group_slug: group_slug,
      start_date: undefined,
      end_date: undefined,
    });
    // downshift needs a string
    this.setState({
      input_groups_width: {
        width: getTextWidth(event.inputValue),
      },
    });

    window.analytics.track("Filter", {
      type: "Group",
      filter_slug: group_slug,
      project: currentProject.project,
      page: currentProject.page,
    });
  };

  onStateChangeGroup = (change, e) => {
    const type = change.type;
    const input = document.getElementById(e.id + "-input");

    if (type === "__autocomplete_item_mouseenter__") {
      input.value = "";
    } else if (type === "__autocomplete_mouseup__") {
      input.value = this.props.pageSettings.state.pageSettings.group_name;
    } else if (type === "__autocomplete_click_item__") {
      input.blur();
    }
  };

  onChangeRegion = (selected_item, event) => {
    const { currentProject } = this.context.state;
    // Remove focus
    document.getElementById(event.id + "-input").blur();

    const region_slug = this.state.regions.find(
      ({ name }) => name === selected_item
    ).slug;

    this.updatePageSettings({
      region_slug: region_slug,
    });

    // downshift needs a string
    this.setState({
      region_name: selected_item,
      input_regions_width: {
        width: getTextWidth(event.inputValue),
      },
    });

    window.analytics.track("Filter", {
      type: "Region",
      filter_slug: region_slug.slug,
      project: currentProject.project,
      page: currentProject.page,
    });
  };

  onStateChangeRegion = (change, e) => {
    const type = change.type;
    const input = document.getElementById(e.id + "-input");

    if (type === "__autocomplete_item_mouseenter__") {
      input.value = "";
    } else if (type === "__autocomplete_mouseup__") {
      input.value = this.state.region_name;
    } else if (type === "__autocomplete_click_item__") {
      input.blur();
    }
  };

  itemToString = (i) => (i ? i.name : "");

  renderGroups = (groups) => {
    let sorted_groups = [];

    if (groups && groups.board && groups.board.groups) {
      groups.board.groups.map((i, key) =>
        sorted_groups.push(groups.board.groups[key])
      );

      sorted_groups.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });

      const hasAllOption = sorted_groups.some((o) => o.name === "All Accounts");

      if (this.default_group.name !== undefined) {
        if (hasAllOption) {
          sorted_groups.shift({
            name: "All Accounts",
            slug: "all",
          });
        }
      } else {
        sorted_groups.unshift({
          name: "All Accounts",
          slug: "all",
        });
      }
    }

    return (
      <div className="row w-100 mb-3 mb-md-1 mt-2 pl-1">
        <div className="col filters">
          <Heading size={6} key={"heading"}>
            <small>Show Data From</small>
          </Heading>
          <div className="d-flex filters-line">
            {sorted_groups ? (
              <Downshift
                selectedItem={
                  this.props.pageSettings.state.pageSettings.group_name
                }
                onChange={(selection, event) =>
                  this.onChangeGroup(selection, event, sorted_groups)
                }
                onStateChange={(changes, stateAndHelpers, e) =>
                  this.onStateChangeGroup(changes, stateAndHelpers, e)
                }
              >
                {({
                  getInputProps,
                  getItemProps,
                  isOpen,
                  toggleMenu,
                  inputValue,
                  highlightedIndex,
                  selectedItem,
                }) => (
                  <div style={{ position: "relative" }}>
                    <input
                      className="filters__input"
                      style={this.state.input_groups_width}
                      autoCorrect="off"
                      autoCapitalize="off"
                      spellCheck="false"
                      id="downshift-input-0"
                      {...getInputProps({
                        placeholder: "Search For",
                        onClick(event) {
                          return (event.currentTarget.value = "");
                        },
                        onFocus() {
                          toggleMenu();
                        },
                      })}
                    />

                    {isOpen ? (
                      <div className="filters-wrapper">
                        <div className="filters-menu">
                          {sorted_groups
                            .filter((i) => {
                              if (inputValue === selectedItem) {
                                return i;
                              } else {
                                return i.name
                                  .toLowerCase()
                                  .includes(inputValue.toLowerCase());
                              }
                            })
                            .map((item, index, arr) => {
                              let itemClass = clsx("filters-menu-item", {
                                "filters-menu-item--active":
                                  highlightedIndex === index,
                                "filters-menu-item--selected":
                                  selectedItem === item.name,
                              });

                              return (
                                <div
                                  {...getItemProps({
                                    key: item + index,
                                    index,
                                    item: this.itemToString(item),
                                    className: itemClass,
                                  })}
                                >
                                  {item.name || ""}
                                </div>
                              );
                            })}
                          {/* <div className="add-group"><a className="add-group-link" onClick={() => { this.handleOpenModal(); toggleMenu() }}>+ Create Custom Group</a></div> */}
                        </div>
                      </div>
                    ) : null}
                  </div>
                )}
              </Downshift>
            ) : null}

            {this.state.regions ? (
              <Fragment>
                <span className="mr-2 ml-2 filters__label"> from: </span>

                <Downshift
                  selectedItem={this.state.region_name}
                  onChange={(selection, event) =>
                    this.onChangeRegion(selection, event)
                  }
                  onStateChange={(changes, stateAndHelpers) =>
                    this.onStateChangeRegion(changes, stateAndHelpers)
                  }
                >
                  {({
                    getInputProps,
                    getItemProps,
                    isOpen,
                    toggleMenu,
                    inputValue,
                    highlightedIndex,
                    selectedItem,
                  }) => (
                    <div style={{ position: "relative" }}>
                      <input
                        className="filters__input"
                        style={this.state.input_regions_width}
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        {...getInputProps({
                          placeholder: "Search For",
                          onClick(event) {
                            return (event.currentTarget.value = "");
                          },
                          onFocus() {
                            toggleMenu();
                          },
                        })}
                      />
                      {isOpen ? (
                        <div className="filters-menu">
                          {this.state.regions
                            .filter((i) => {
                              if (inputValue === selectedItem) {
                                return i;
                              } else {
                                return i.name
                                  .toLowerCase()
                                  .includes(inputValue.toLowerCase());
                              }
                            })
                            .map((item, index) => {
                              let itemClass = clsx("filters-menu-item", {
                                "filters-menu-item--active":
                                  highlightedIndex === index,
                                "filters-menu-item--selected":
                                  selectedItem === item.name,
                              });

                              return (
                                <div
                                  {...getItemProps({
                                    key: item + index,
                                    index,
                                    item: this.itemToString(item),
                                    className: itemClass,
                                  })}
                                >
                                  {item.name || ""}
                                </div>
                              );
                            })}
                        </div>
                      ) : null}
                    </div>
                  )}
                </Downshift>
              </Fragment>
            ) : null}
          </div>
        </div>
      </div>
    );
  };

  updatePageSettings = (obj) => {
    const { dispatch } = this.props.pageSettings;
    dispatch({
      type: "PAGE-SET-SETTINGS",
      payload: obj,
    });
  };

  componentDidMount() {
    this.default_group = this.getActiveBoard().defaultGroup || false;
    this.default_filter = this.getActiveBoard().defaultFilter || false;
    this.default_region = this.getActiveBoard().defaultRegion || false;

    this.updatePageSettings({
      group_name: this.default_group.name || "All Accounts",
      group_slug: this.default_group.slug || "all",
      region_slug: this.default_region.slug || null,
      filter_id: this.default_filter.id || DEFAULT_FILTER.id,
    });

    this.setState({
      contextDataLoaded: true,

      regions: this.getRegions().length > 0 ? this.getRegions() : false,
      region_name: this.default_region.name || null,
      region_name_current: this.default_region.name || null,

      input_groups_width: {
        width: getTextWidth(this.default_group.name || "All Accounts"),
      },
      input_filter_width: {
        width: getTextWidth(this.default_filter.name || DEFAULT_FILTER.name),
      },
      input_regions_width: {
        width: getTextWidth(this.default_region.name || "All Regions"),
      },
    });
  }

  renderAlerts = (alerts) => {
    const hiddenAlerts = window.localStorage.getItem("hideAlerts")
      ? JSON.parse(window.localStorage.getItem("hideAlerts"))
      : [];

    return alerts
      .filter((alert) => !hiddenAlerts.includes(alert.id))
      .map((alert, i) => {
        return <Alert {...alert} key={i} className="mb-2" />;
      });
  };

  render() {
    if (!this.state.contextDataLoaded) return null;
    const { currentProject } = this.context.state;

    const tenantID = parseInt(localStorage.defaultTenantID);
    const alerts = this.context.state.config.alerts?.length > 0;

    return (
      <div className="container-wrapper">
        <div className="container-fluid">
          {alerts && this.renderAlerts(this.context.state.config.alerts)}

          {currentProject.boardObj.showGroups && (
            <div className="col-12 filters-wrapper mb-3 mb-md-0 pl-2">
              <Query
                query={QUERY_LIST_GROUPS}
                variables={{
                  id: currentProject.boardObj.id,
                  tenantID: tenantID,
                }}
                onCompleted={(data) =>
                  this.setState({ groups: data.board.groups })
                }
                client={client}
              >
                {({ loading, error, data }) => {
                  if (error) {
                    return (
                      <div className="col-2">
                        <small>Error loading groups</small>
                      </div>
                    );
                  }

                  if (loading) {
                    return <div className="col-2" />;
                  }

                  if (data) {
                    return this.renderGroups(data);
                  }
                }}
              </Query>
            </div>
          )}
          {/* Displays the board filters */}
          {currentProject.boardObj.showFilters && (
            <div className="row board-filter-container">
              <PageFilterContainerLoadDimensions
                dimensions={this.getActiveBoard().filterDimensions}
                parentProps={this.props}
              />
            </div>
          )}
          {currentProject.boardObj.maintenance ? (
            <Notification text="This Page is in Maintenance Mode." />
          ) : (
            <Page
              pageSettings={this.props.pageSettings}
              projectSettings={currentProject}
            />
          )}
          <Footer />
        </div>
      </div>
    );
  }
}

export default withRouter((props) => (
  <PageContextProvider>
    <PageContextConsumer>
      {(pageSettings) => (
        <PageContainer {...props} pageSettings={pageSettings} />
      )}
    </PageContextConsumer>
  </PageContextProvider>
));
